var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 45",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "ccSecurityTitle"
  }, "Credit Card Security Codew") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "ccSecurityTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "securityNeurtal3",
    d: "M53.18,37c-4.963,0-9-4.037-9-9s4.037-9,9-9,8.999,4.037,8.999,9-4.037,9-8.999,9ZM53.18,19.7c-4.577,0-8.301,3.724-8.301,8.3s3.724,8.301,8.301,8.301,8.3-3.724,8.3-8.301-3.724-8.3-8.3-8.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "securityNeurtal4",
    d: "M47.452,29.999h1.167v-3.742h-.936v-.432c.473-.08.808-.208,1.088-.376h.512v4.55h1.047v.552h-2.878s0-.552,0-.552Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "securityNeurtal4",
    d: "M51.397,30.143c1.519-1.486,2.398-2.431,2.398-3.254,0-.584-.32-.991-.968-.991-.424,0-.792.271-1.079.607l-.376-.359c.424-.48.88-.792,1.535-.792.943,0,1.535.6,1.535,1.495,0,.991-.896,1.911-2.135,3.175.28-.024.592-.04.855-.04h1.527v.567h-3.294v-.408h.002Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "securityNeurtal4",
    d: "M55.54,29.927l.336-.432c.304.32.703.6,1.304.6.615,0,1.055-.359,1.055-.927,0-.608-.416-1.016-1.631-1.016v-.504c1.079,0,1.447-.416,1.447-.951,0-.488-.336-.8-.88-.8-.424,0-.783.216-1.087.512l-.352-.416c.391-.368.863-.64,1.463-.64.887,0,1.527.472,1.527,1.295,0,.616-.368,1.008-.92,1.216v.032c.615.144,1.104.592,1.104,1.295,0,.903-.752,1.455-1.688,1.455-.815,0-1.335-.344-1.679-.72h.001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "securityNone",
    d: "M67,6.5c0-3.033-2.468-5.5-5.5-5.5H6.5C3.467,1,1,3.467,1,6.5v.5h66v-.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "securityNone",
    d: "M1,38.5c0,3.032,2.467,5.5,5.5,5.5h55c3.032,0,5.5-2.468,5.5-5.5v-22.5H1v22.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "securityNeurtal2",
    x: 1,
    y: 7,
    width: 66,
    height: 9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "securityNeurtal3",
    d: "M61.5,0H6.5C2.916,0,0,2.916,0,6.5v32c0,3.584,2.916,6.5,6.5,6.5h55c3.584,0,6.5-2.916,6.5-6.5V6.5c0-3.584-2.916-6.5-6.5-6.5ZM67,38.5c0,3.032-2.468,5.5-5.5,5.5H6.5c-3.033,0-5.5-2.468-5.5-5.5V6.5C1,3.467,3.467,1,6.5,1h55c3.032,0,5.5,2.467,5.5,5.5v32Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCode);
export default __webpack_public_path__ + "static/media/Security Code.bff6f4afc6c1d27586535ad924436b2a.svg";
export { ForwardRef as ReactComponent };